var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('breadcrumb-nav',{scopedSlots:_vm._u([{key:"firstMenu",fn:function(){return [_vm._v("商品管理")]},proxy:true},{key:"secondMenu",fn:function(){return [_vm._v("商品分类")]},proxy:true}])}),_c('category-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }